import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    t
  } = useLang();
  return <section className="py-24 bg-dark" data-id="element-2" data-mp="1ixrombzzcs22">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3" data-mp="1nu9qn43xecap">
        <div className="text-center mb-16" data-id="element-4" data-mp="1nwmetz0a1iw7">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-5" data-mp="2bk41xh8ljssu">
            {t.faq.title} <span className="text-gold" data-id="element-6" data-mp="2fmh6w3firmok">{t.faq.titleHighlight}</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-7" data-mp="21v2lxr21xbev">
          {t.faq.items.map((faq, index) => <div key={index} className="bg-dark-100 border border-white/10 rounded-2xl overflow-hidden transition-all duration-300" data-id="element-8" data-mp="26tdttw8sdbug" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-9" data-mp="2uh5998pmi4zy">
                <span className="text-white font-bold pr-8" data-id="element-10" data-mp="1rpqun70a43cp">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-gold shrink-0" data-id="element-11" data-mp="25hnmd9y1cb8k" /> : <ChevronDown className="w-5 h-5 text-gray-500 shrink-0" data-id="element-12" data-mp="20mrh383sfrdi" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-13" data-mp="2ffla7wbzg60n">
                <p className="text-gray-400 text-sm border-t border-white/5 pt-4" data-id="element-14" data-mp="2jfc78hs3ridm">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}